import React from "react";

interface IProp {
  user: any;
  isAdmin: boolean;
}
export const User = (prop: IProp) => {
  const { user, isAdmin } = prop;
  return (
    <nav className="navbar" role="navigation" aria-label="main navigation">
      <div className="navbar-menu">
        <div className="navbar-start">
          <a className="navbar-item">{user.attributes.email}{isAdmin ? '*' : null}</a>
        </div>
      </div>
    </nav>
  );
};
